<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>

          <Alert type="warning" show-icon>
            友情提示：
            <template slot="desc">
              <Row type="flex" justify="center" align="top" class="code-row-bg">

                <Col span="20" > 1、请对每一位求职者进行求职操作，如长时间未操作可能对您的账号使用造成影响。
                  <br>
                  2、扫描右方二维码关联微信号，可收到求职消息提醒。</Col>
                <Col span="4" ><div class="qrcode" ref="qrCodeUrl"></div></Col>
              </Row>

              <!--              <br>-->
              <!--              4、远程面试实景检测室提供太仓市人力资源市场实景面试室画面，可登录确认您的实机环境和效果。-->
            </template>

          </Alert>

          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>

          </div>

          <Spin size="large" fix v-if="spinShow"></Spin>

          <Table size="small" ref="table_" border :columns="columns_in" :data="tableData" height="600"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
        </Card>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <el-drawer
      title="个人信息"
      :visible.sync="msgmodal"
      direction="ltr"
      size="30%"
      style="overflow: auto;">
      <el-divider></el-divider>

      <el-form ref="form" :model="formValidate_per" label-width="100px">

        <el-form-item label="姓名：">
          {{ formValidate_per.Pname }}
        </el-form-item>
        <el-form-item label="性别：">
          {{ formValidate_per.Psex_CN }}
        </el-form-item>
        <el-form-item label="类型：">
          {{ formValidate_per.Pstype_CN }}
        </el-form-item>
        <el-form-item label="年龄：">
          {{ formValidate_per.age }}
        </el-form-item>
        <el-form-item label="身份证：">
          {{ formValidate_per.Perinfo.Pidcard }}
        </el-form-item>
        <el-form-item label="地址：">
          {{ formValidate_per.Perinfo.Paddress }}
        </el-form-item>
        <el-form-item label="现居住区域：">
          {{ formValidate_per.Pnowaddress }}
        </el-form-item>
        <el-form-item label="电话：">
          {{ formValidate_per.Perinfo.Pphone }}
        </el-form-item>
        <el-form-item label="婚姻：">
          {{ formValidate_per.Pmarriage_CN }}
        </el-form-item>
        <el-form-item label="民族：">
          {{ formValidate_per.Pnation_CN }}
        </el-form-item>
        <el-form-item label="学历：">
          {{ formValidate_per.Peducation_CN }}
        </el-form-item>
        <el-form-item label="工作年限：">
          {{ formValidate_per.Pexperience_CN }}
        </el-form-item>

        <el-form-item label="期望薪酬：">
          {{ formValidate_per.Psalary_CN }}
        </el-form-item>
        <el-form-item label="简历：">
          <el-image
            style="width: 100px; height: 100px"
            :src="formValidate_per.perpic"
            :preview-src-list="formValidate_per.perpiclist">
          </el-image>
        </el-form-item>
      </el-form>

    </el-drawer>
  </div>
</template>
<script>

import {
  getapplyapplication,
  perinbox
} from '@/api/apply/apply.js'

import { getsysparameterList } from '@/api/system/sys_parameter'
import QRCode from 'qrcodejs2'
import { forEach } from '@/libs/tools'
// import {Notification} from 'element-ui';

let moment = require('moment')
export default {

  data () {
    return {
      url_cid: 0,
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数
      msgmodal: false,
      formValidate_per: {
        Perinfo: {}
      },
      columns_in: [
        {
          type: 'selection',
          key: 'Id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '姓名',
          key: 'Pname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 100,
          render: (h, params) => {
            return h('a', {
                on: {
                  click: () => {
                    this.perinfo_show(params.row)
                  }
                }
              }, params.row.Pname
            )
          }
        },
        {
          title: '身份证',
          key: 'Pidcard',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 180
        },
        {
          title: '应聘岗位',
          key: 'Jobname',
          align: 'center',
          fixed: 'left',
          sortable: true,
          width: 140
        },
        {
          title: '性别',
          key: 'Psex_CN',
          align: 'center',
          sortable: true,
          width: 80
        },
        {
          title: '年龄',
          key: 'age',
          align: 'center',
          sortable: true,
          width: 80
        },
        {
          title: '类型',
          key: 'Pstype_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '住址',
          key: 'Paddress',
          align: 'center',
          sortable: true,
          width: 250
        },
        {
          title: '现居住地',
          key: 'Pnowaddress',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '现居住地',
          key: 'Pnowaddress',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '联系电话',
          key: 'Pphone',
          align: 'center',
          fixed: 'right',
          sortable: true,
          width: 120
        },
        {
          title: '学历',
          key: 'Peducation_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '工作经验',
          key: 'Pexperience_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '婚姻',
          key: 'Pmarriage_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '民族',
          key: 'Pnation_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '期望薪资',
          key: 'Psalary_CN',
          align: 'center',
          sortable: true,
          width: 120
        },
        {
          title: '应聘日期',
          key: 'Aintime',
          align: 'center',
          sortable: true,
          width: 180
        },
        {
          title: '招聘会',
          key: 'Jobfairname',
          align: 'center',
          sortable: true,
          width: 180
        },

        {
          title: '状态',
          key: 'handle',
          width: 100,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', { props: { color: params.row.Astate_col } }, params.row.Astate_CN)
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            if (params.row.Astate != 3 && params.row.Astate != 4) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.perinbox(params.row, 3)
                      }
                    }
                  },
                  '拟录用'
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.perinbox(params.row, 4)
                      }
                    }
                  },
                  '不录用'
                )
              ])
            }
          }
        }
      ]
    }
  },
  beforeRouteLeave (to, from, next) {
    var show = 0
    this.tableData.forEach(function (item, index) {
      var dateEnd = new Date()
      var dateBegin = new Date(item.Aintime.replace(/-/g, '/'))
      let dateDiff = dateEnd.getTime() - dateBegin.getTime()
      let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))
      console.log(dayDiff)
      console.log(item.Aintime)
      if (item.Astate == 1 && dayDiff > 0) {
        show = 1
      }
    })
    if (show == 1) {
      this.showcompanymsg()
    } else {
      next()
    }
  },
  methods: {
    showcompanymsg () {
      this.$confirm('无法进行其他操作，请优先处理求职信息?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {

      }).catch(action => {
        if (action === 'cancel') {

        }
      })
    },
    creatQrCode () {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: 'https://ljtc.tcrc.com.cn?c=' + this.url_cid.toString(), // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    perinfo_show (val) {
      this.msgmodal = true
      this.formValidate_per = val
    },
    getapplyapplication (key, Cid) {
      this.spinShow = true
      // console.log(this.jobfair_info.Id)
      getapplyapplication(this.pageNum, this.pageSize, key, Cid).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data
          this.pageTotal = res.data.count

          if (res.data.cid && this.url_cid == 0) {
            this.url_cid = res.data.cid
            this.creatQrCode()
          }
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    perinbox (row, Iresult) {
      let that = this
      // row.Astate = Iresult
      let postdata = {
        'Id': row.Id,
        'Astate': Iresult,
        'Popenid': row.Perinfo.Popenid,
        'Cname': row.Cname,
        'Jobname': row.Jobname,
        'Jphone': row.Jphone
      }
      perinbox(postdata).then(res => {
        if (res.data.code === 0) {
          that.getapplyapplication()
          // that.getperjob(that.formValidate_company.Id)
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    handleRemove (index) {
      this.formValidate.args_items[index].status = 0
    },

    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })

      this.tableSelectIdList = SelectIdList
    },

    handleSearch () {
      this.getapplyapplication(this.searchVal)
    },
    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getapplyapplication(this.searchVal)
      } else {
        this.getapplyapplication()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getapplyapplication(this.searchVal)
      } else {
        this.getapplyapplication()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getapplyapplication(this.searchVal)
      } else {
        this.getapplyapplication()
      }
    }
  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getapplyapplication()
  }
  // head: {
  //   script: [
  //     { src: "http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js" }
  //   ]
  // }
}

</script>
<style lang="css" >
.el-drawer {
  overflow: auto;
}
</style>
<style lang="less" scoped>

.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
